export default {
    delete_webhook_title: 'Eliminar Webhook',
    delete_webhook_confirm: '¿Estás seguro de que deseas eliminar este webhook?',
    delete_webhook_success: 'Webhook eliminado exitosamente',
    delete_webhook_error: 'Error al eliminar el webhook',
};
